import { createFileRoute } from '@tanstack/react-router'

import LoginPage from '@/views/auth/login/login.page'

export const Route = createFileRoute('/_layout/auth/login')({
  component: LoginPage,
})
